import React from 'react';

const NotFound = () => {
    return (
        <p>頁面建構中</p>
    )
}

export default NotFound;